function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFax(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 10a4 4 0 00-4 4v14h28V14a4 4 0 00-4-4H6zm0 2a2 2 0 00-2 2v12h24V14a2 2 0 00-2-2H6z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 24h2v-2h-2v2zM14 20h2v-2h-2v2zM18 20h2v-2h-2v2zM22 20h2v-2h-2v2zM14 16h10v-2H14v2zM14 24h2v-2h-2v2zM18 24h2v-2h-2v2zM10 4h12v4h2V4a2 2 0 00-2-2H10a2 2 0 00-2 2v4h2V4z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 14,
    width: 4,
    height: 10,
    rx: 2,
    fill: props.color
  }));
}

export default SvgIconFax;